import * as types from "../types";

const initialState = {
  loading: false,
  requestData: null,
  res: null,
  error: null,
};

export default function mobileNumberReducer(state = initialState, action) {
  switch (action.type) {
    case types.CHECK_MOBILE_REQUEST:
      return {
        ...state,
        loading: true,
        requestData: action.payload.requestData,
      };

    case types.CHECK_MOBILE_SUCCESS:
      return {
        ...state,
        loading: false,
        res: action.payload.res,
      };

    case types.CHECK_MOBILE_FAILURE:
      return {
        ...state,
        loading: false,
        requestData: null,
        res: null,
        error: action.payload.error,
      };

    case types.RESET_CHECK_MOBILE:
      return {
        ...state,
        loading: false,
        requestData: null,
        res: null,
        error: null,
      };

    default:
      return state;
  }
}
